module.exports = __webpack_public_path__ + "static/img/hover3.c7eef970.png";